import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import {  MatDialogConfig } from '@angular/material/dialog';
import { apisDataCacheKeys, ApiUrlConstant } from '@app-constants/app.constants';
import { RestApiService } from '@app-services/rest/rest-api.service';
import { ReferralDialogComponent } from '@app-shared/components/referral-dialog/referral-dialog.component';
import { Observable } from 'rxjs';
import { takeLast } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class InviteEarnService extends RestApiService {
  apiUrl:any=ApiUrlConstant.uafapi;
  omsUrl:any = ApiUrlConstant.omsdevapi;
  myActivityUrl:any = ApiUrlConstant?.myActivity;

  setRefToLocalStorage(id:any,refLink:any,textAreaLink:any){ //? setId to localStorage
    localStorage.setItem('mUserRefId',id);
    localStorage.setItem('mUserRefLink',refLink);
    localStorage.setItem('textAreaLink',textAreaLink);
  }
  getGradeId() {
    const userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    return userData?.grade?.gradeId;
  }

  getUserInfo() {
    const userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    return {
      phone_number: Number(userData.phone),
      email: userData?.email || "",
      userId: userData?.userId?.toString(),
      name: userData?.firstName + userData.lastName,
      type: "free"
    }
  }

  getUserAcademics() {
    const userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    return {
      class: userData?.grade?.name,
      stream: userData?.stream?.name,
      target_exams: JSON.stringify(userData?.exams?.map((exam) => {
        let obj = {};
        obj[exam.name] = {
          exam_id: exam.examId,
          target_year : 0,
          exam_progress : 0,
          focused_exam : exam.name === (localStorage.getItem('examName') || localStorage.getItem('targetExamName'))
        };
        return obj;
      }))
    }
  }

  getHeaders() {
    return {
      tenantId: JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))?.tenantId.toString(),
      // subTenantId: 0
    };
  }

  getReq(url: any) {
    return this.getWithHeaders(url, this.getHeaders());
  }
  
  postReq(url: any, payload: any) {
    return this.post(url, payload, this.getHeaders());
  }
  
  generateReferralCode( userId:any, userName: any, badgeId?:any): Observable<any> {
    let _badgeId=badgeId ? badgeId:''
    const url = this.apiUrl + `referral/userReferral/generate?userId=${userId}&userName=${userName}&badgeId=${_badgeId}`;
    return this.postReq(url, {}).pipe(takeLast(1))  ;
  }

  getUserDeatailsByReferralId(userRefId:any){
    const url= this.apiUrl+`referral/userReferralMapping/userReferralId?userReferralId=${userRefId}`
    // const url= this.apiUrl+`referral/userReferralMapping/3`
    return this.getReq(url);
  }

  remindUser(userRefId:any){
    const url= this.apiUrl+`referral/userReferralMapping/remind/userReferralMappingId?userReferralMappingId=${userRefId}`
    return this.postReq(url,{});
  }

  sendNewRegisteredData(referralCode:any, userId:any, userName: any): Observable<any> {
    const url = this.apiUrl + `referral/userReferralMapping?referalCode=${referralCode}&userFullName=${userName}&userId=${userId}`;
    return this.postReq(url,{});
  }

  sendModeOfShareDetails(modeOfShare:any, userRferralId:any){
    const url = this.apiUrl + `referral/userReferralDetails?modeOfShare=${modeOfShare}&userReferralId=${userRferralId}`;
    return this.postReq(url,{});
  }

  sendFeedbackData(currentLoginCount:any,productId:any,rating:any,userId:any){
    // {
    //   "currentLoginCount": 0,
    //   "productId": 0,
    //   "rating": 0,
    //   "userId": 0
    // }
    // https://uafstgapi.devinfinitylearn.in/api/rating/userProductRating/productRating
    let body= 
    {
        "currentLoginCount":currentLoginCount,
        "productId":productId,
        "rating": rating,
        "userId": userId
      }
    const url = this.apiUrl + `rating/userProductRating/productRating`;
    return this.postReq(url,body);
  }

  remindMeLaterPopup(userPositiveLoginDetailsId: any){
    const url = this.apiUrl + `rating/userPositiveLoginDetails/remindMeLater?userPositiveLoginDetailsId=${userPositiveLoginDetailsId}`;
    return this.postReq(url,{});
  }
  // http://localhost:8081/api/discountcodes/createCode%22
  createDiscountCode(obj){
    const url = this.omsUrl + `discountcodes/createReferralDiscountCode`;
    return this.postReq(url,obj);
  }

  userReferralRemider(userId:any,obj:any){
    const url = this.myActivityUrl + `api/userreferralreminderdetails/reminderStatus?userId=${userId}`;
    return this.postReq(url,obj);
  }

  saveReferralRemider(userId:any,obj:any){
      const url = this.myActivityUrl + `api/userreferralreminderdetails/save/saveReferralReminder?userId=${userId}`;
      return this.postReq(url,obj);
    }
  
  getOwnerDetails(code): Observable<any> {
    const url = this.apiUrl + `referral/userReferral/referralcode?referalCode=${code}`;
    return this.get(url);
  }

  invokeReferralDialog(dialog:any,userId:any,isFrom?:any,eventHandlingService?:any,router?:any){
    const config: MatDialogConfig = {
      width: '450px',
      height: '365px',
      data: {  
        userId:userId
      },
      scrollStrategy: new NoopScrollStrategy(),
      disableClose:true,
      panelClass: [
        'UNFAPP-mweb-btmstiky-modal'
      ],
    };
    let dialogRef = dialog?.open(ReferralDialogComponent, config);
    dialogRef?.afterClosed()?.subscribe((res)=>{
      if(isFrom == 'FromFeedback'){
        eventHandlingService?.liveClassAction({ event: 'leaveZoomSession' });
      }else if(isFrom == 'youtube'){
        router.navigateByUrl('dashboard/liveclass');
      }
   })
  }

  referralDeepLink(discountCode:any,percentage:any,days:any,textAreaLink:any){
    return (
      `Hi! Here’s a fun learning App with live classes, videos, flashcards, mock tests, instant doubt clarification and much more. Use my coupon *${discountCode}* to get ${percentage}% off on all packages. Valid only for next ${days} days.\n` +
      textAreaLink
    );
  }

  getMonthDaysLeft(){
    const date = new Date();
    let daysLeft:any
    daysLeft = (new Date(date?.getFullYear(), date?.getMonth() + 1, 0)?.getDate() - date?.getDate()) + 1
    daysLeft = daysLeft < 10 ? `0${daysLeft}` : daysLeft
    return `${daysLeft} ${daysLeft == 1 ? 'day left' : 'days left'}`
  }
}
